import React, { useState, useEffect, useRef } from "react";
import {
  TabPane,
  Row,
  Col,
  Label,
  Input,
  Tooltip,
  Spinner,
  Button
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";

import { ArrowRight, CheckCheck } from "lucide-react";
import { LuRefreshCw } from "react-icons/lu";

import axiosInstance from 'utils/axiosInstance';

import HoverInfo from "components/Common/HoverInfo";
import "components/Common/HoverInfo.css";

import StatsCommentTextArea from "./StatsCommentTextArea";
import StatsPane from "./StatsPane";

import { TransitionGroup, CSSTransition } from 'react-transition-group';

const QuestionPane = ({ 
  t,
  subIndex,
  myInfoQuestionSet, 
  infoQuestion, 
  resizeSignal,

  visibleStats,
  toggleStatsOpen,
  animatingStats,

  questionStats, 
  setQuestionStats,
  loadStats,

  answers,
  hasVerifiedAnswers,
  hasWrongAnswers,
  verifiedAnswers,
  answerAwaitVerifying,
  hasConfirmedAnswers,
  confirmedAnswers,
  answerAwaitSaving,
  resolvedAnswerBuckets,

  showAffectedAttributes,
  showVerificationRules,
  showActivationConditions,
  ruleVerificationStatus,
  
  handleInputChange,
  handleVerify,
  handleSave,
}) => {

  const nodeRef = useRef(null);
  const navigate = useNavigate();

  const questionId = infoQuestion._id;


  //--------------------------------------------------
  // ThumbUps and ThumbDowns
  //--------------------------------------------------
  /*
  const handleThumbsUp = async (questionId) => {
    try {
      const prev = questionStats[questionId];
      const isCancelling = prev?.hasRated && prev.value === 'up';

      const res = await axiosInstance.patch(`/knovia/myInfo/questions/${questionId}/rate`, {
        isThumbsUp: !isCancelling ? true : true // always send `true`, let backend handle
      });

      setQuestionStats(prev => ({
        ...prev,
        [questionId]: {
          ...prev[questionId],
          thumbsUp: isCancelling
            ? prev[questionId].thumbsUp - 1
            : prev[questionId].thumbsUp + 1,
          thumbsDown: prev[questionId].value === 'down'
            ? prev[questionId].thumbsDown - 1
            : prev[questionId].thumbsDown,
          hasRated: !isCancelling,
          value: isCancelling ? null : 'up',
          ratedAt: new Date().toISOString()
        }
      }));
    } catch (err) {
      console.log(err.response?.data?.message || "Rating failed.");
    }
  };

  const handleThumbsDown = async (questionId) => {
    try {
      const prev = questionStats[questionId];
      const isCancelling = prev?.hasRated && prev.value === 'down';

      const res = await axiosInstance.patch(`/knovia/myInfo/questions/${questionId}/rate`, {
        isThumbsUp: !isCancelling ? false : false // always send `true`, let backend handle
      });

      setQuestionStats(prev => ({
        ...prev,
        [questionId]: {
          ...prev[questionId],
          thumbsDown: isCancelling
            ? prev[questionId].thumbsDown - 1
            : prev[questionId].thumbsDown + 1,
          thumbsUp: prev[questionId].value === 'up'
            ? prev[questionId].thumbsUp - 1
            : prev[questionId].thumbsUp,
          hasRated: !isCancelling,
          value: isCancelling ? null : 'down',
          ratedAt: new Date().toISOString()
        }
      }));
    } catch (err) {
      console.log(err.response?.data?.message || "Rating failed.");
    }
  };
  */

  //--------------------------------------------------
  // Reload Question Stats
  //--------------------------------------------------
  /*
  const [justRefreshed, setJustRefreshed] = useState({});
  const reloadStats = async (questionId) => {
    await loadStats(); // Your actual stat loader
    setJustRefreshed(prev => ({ ...prev, [questionId]: true }));
    setTimeout(() => {
      setJustRefreshed(prev => ({ ...prev, [questionId]: false }));
    }, 1000);
  };
  */


  //--------------------------------------------------
  // Comment Input
  //--------------------------------------------------
  /*
  const [statsComments, setStatsComments] = useState({});
  useEffect(() => {
    if (!questionStats || Object.keys(questionStats).length === 0) return;

    setStatsComments((prev) => {
      const newStatsComments = { ...prev };
      for (const [questionId, stat] of Object.entries(questionStats)) {
        // Initialize if not already typed by the user
        if (newStatsComments[questionId] === undefined) {
          newStatsComments[questionId] = stat.comment || "";
        }
      }
      return newStatsComments;
    });
  }, [questionStats]);
  */


  //--------------------------------------------------
  // Comment Input and Resize
  //--------------------------------------------------
  /*
  const textareaRefs = useRef({});
  const handleStatsCommentChange = (id, e) => {
    setStatsComments(prev => ({
      ...prev,
      [id]: e.target.value,
    }));
  }
  const registerRef = (questionId, ref) => {
    textareaRefs.current[questionId] = ref;
  };

  useEffect(() => {
    const handleResize = () => {
      Object.values(textareaRefs.current).forEach((ref) => {
        if (ref?.current) {
          ref.current.style.height = "auto";
          ref.current.style.height = `${ref.current.scrollHeight}px`;
        }
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // on mount

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */


  //--------------------------------------------------
  // Save Comment Input
  //--------------------------------------------------
  /*
  const [commentInputOpen, setCommentInputOpen] = useState({});
  const [commentInputSending, setCommentInputSending] = useState({});
  const [commentInputSent, setCommentInputSent] = useState({});
  const toggleCommentInput = (id) => {
    setCommentInputOpen(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const sendCommentInput = async (questionId) => {
    setCommentInputSending(prev => ({
      ...prev,
      [questionId]: true,
    }));
    try {
      const newComment = statsComments[questionId];

      if(!newComment){ return; }
      const res = await axiosInstance.patch(`/knovia/myInfo/questions/${questionId}/statsComment`, {
        newComment: newComment
      });

      setStatsComments(prev => ({
        ...prev,
        [questionId]: res.data.savedComment
      }));

    } catch (err) {
      console.log(err.response?.data?.message || "Stats comment failed.");
    } finally {
      setCommentInputSending(prev => ({
        ...prev,
        [questionId]: false,
      }));
      setCommentInputSent(prev => ({
        ...prev,
        [questionId]: true,
      }));
      setTimeout(()=>{
        setCommentInputSent(prev => ({
          ...prev,
          [questionId]: false,
        }));
      }, 2000)
    }
  };
  */
  

  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight(); // Run on mount or when answer changes
  }, [answers[infoQuestion._id]]);

  useEffect(() => {
    adjustHeight();
  }, [resizeSignal]);


  return (
    <TabPane tabId={infoQuestion._id} key={infoQuestion._id}>
      <Row style={{ marginLeft: '0', marginRight: '0' }}>
        <TransitionGroup component={null}>

          <CSSTransition
            key={questionId}
            timeout={1000}
            classNames="fade-slide"
            nodeRef={nodeRef.current}              // pass the ref object
            onExit={() => {
              const el = nodeRef.current;  // safe: always an element
              el.style.maxHeight = `${el.scrollHeight}px`;
            }}
            onExiting={() => {
              const el = nodeRef.current;
              el.style.maxHeight = '0px';
            }}
            appear
          >
            <div ref={nodeRef.current} className="question-set-input-question-outer-div">
              <Col md="12" className="mb-2">

                {subIndex !== 0 &&
                  <div className="question-set-input-section-div" style={{ marginBottom: "20px" }}/>
                }
                <Row>
                  <Col xs={12}>
                    <pre className="question-set-input-question-label">{infoQuestion.label}</pre>
                  </Col>
                </Row>

                <Row className={confirmedAnswers[questionId] ? "mb-1" : "mb-3"} style={{ display: "flex" }}>

                  <Col xs={8} className="d-flex flex-column" style={{ paddingTop: "0px" }}>
                    {/* Activation Condition */}
                    <Row>
                      {showActivationConditions && (
                        <Col xs={6}>
                          {infoQuestion?.dependencies.activationConditionSets.map((set, setIndex) => (
                            <div key={setIndex} 
                              style={{ 
                                marginBottom: "0.15rem", textAlign: "right",
                                borderBottom: setIndex===infoQuestion?.dependencies.activationConditionSets.length-1 ? 
                                null : "1px solid #6facb6"
                              }}
                            >
                              {set.conditions.map((condition, condIndex) => {
                                return (
                                  <p key={condIndex} style={{ margin: "0", fontSize: "11px", color: "#6f8ab6" }}>
                                    {`${condIndex+1}. ${condition}`}
                                  </p>
                                );
                              })}
                            </div>
                          ))}
                        </Col>
                      )}
                    </Row>

                    {/* Question Input */}
                    <Row>
                      <Col xs={12} className="d-flex flex-column" style={{ paddingTop: "0px" }}>
                        <textarea ref={textareaRef} rows={1}
                          style={{ resize: "none" }}
                          className="form-control"
                          value={answers[infoQuestion._id] || ""}
                          onChange={(e) => {
                            handleInputChange(infoQuestion._id, e)
                            adjustHeight(); // immediate feedback
                          }}
                          disabled={answerAwaitSaving}
                        />
                      </Col>
                    </Row>

                    {/* Affected Attributes */}
                    <Row>
                      {showAffectedAttributes && (
                        <Col xs={6}>
                          <div style={{ marginTop: "0.3rem" }}>
                            {infoQuestion?.verifyRuleAI.map((set, setIndex) => {
                              return (
                                <div key={setIndex} 
                                  style={{ 
                                    marginBottom: "0.15rem", textAlign: "right",
                                    borderBottom: setIndex===infoQuestion?.verifyRuleAI.length-1 ? 
                                    null : "1px solid #ced4da"
                                  }}
                                >
                                  <Row>
                                    <Col xs={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                      {verificationDetails[infoQuestion._id]?.length && (
                                        <>
                                          <span
                                            id={`tooltip-${infoQuestion._id}-${setIndex}`}
                                            style={{ cursor: "pointer", marginLeft: "0.3rem" }}
                                          >
                                            <i className="bx bx-help-circle" style={{ fontSize: "14px", color: "#9b9b9b" }}></i>
                                          </span>
                                          <Tooltip
                                            placement="top"
                                            isOpen={tooltipOpen[`${infoQuestion._id}-${setIndex}`]}
                                            target={`tooltip-${infoQuestion._id}-${setIndex}`}
                                            toggle={() => toggleTooltip(`${infoQuestion._id}-${setIndex}`)}
                                          >
                                            {verificationDetails[infoQuestion._id][setIndex].fullResponse}
                                          </Tooltip>
                                        </>
                                      )}
                                    </Col>
                                    <Col xs={10}>
                                      {set.conditions.map((condition, condIndex) => {
                                        const overallIndex =
                                          infoQuestion.verifyRuleAI
                                            .slice(0, setIndex)
                                            .reduce((acc, prevSet) => acc + prevSet.conditions.length, 0) + condIndex;

                                        let color = "#9b9b9b";
                                        if (ruleVerificationStatus[infoQuestion._id]) {
                                          color =
                                            ruleVerificationStatus[infoQuestion._id][overallIndex] === "YES"
                                              ? "#2e9f6f"
                                              : "#f95a5a";
                                        }
                                        return (
                                          <p key={condIndex} style={{ margin: "0", fontSize: "11px", color }}>
                                            {`(${condIndex+1}) ${condition}`}
                                          </p>
                                        );
                                      })}
                                    </Col>
                                  </Row>

                                </div>
                              )})
                            }
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>


                  {/* Verify and Save Buttons */}
                  <Col xs="4" md="2">
                    <div className="d-flex flex-row flex-nowrap align-items-start">
                      <Button
                        color={ hasVerifiedAnswers[questionId] ? "outline-success" : (hasWrongAnswers[questionId] ? "outline-danger" : "outline-warning") }
                        style={{ marginRight: "0.3rem", fontSize: "20px", padding: "0.1rem 0.4rem" }}
                        onClick={() => handleVerify(questionId)}
                        disabled={
                          hasVerifiedAnswers[questionId] ||
                          hasWrongAnswers[questionId] || 
                          verifiedAnswers[questionId] === answers[questionId]
                        }
                      >
                        {answerAwaitVerifying === questionId ? (
                          <div style={{ fontSize: "6px", padding: "7.2px 2px 5.3px 2px" }}>
                            <Spinner
                              style={{ color: "#f1b34c", height: "16px", width: "16px", margin: "0" }}
                            />
                          </div>
                        ) : (
                          <i className="bx bx-list-check"></i>
                        )}
                      </Button>

                      <Button
                        color={ 
                          hasConfirmedAnswers[questionId] 
                          ? "outline-success" 
                          : (hasVerifiedAnswers[questionId] 
                            ? "outline-info" 
                            : (answers[infoQuestion._id]===confirmedAnswers[infoQuestion._id] ? "outline-success" : "outline-secondary")) 
                        }
                        style={{ padding: "5px 7px 7px 7px" }}
                        onClick={() => handleSave(questionId)}
                        disabled={
                          !hasVerifiedAnswers[questionId] ||
                          !!confirmedAnswers[questionId] ||
                          answerAwaitSaving === questionId
                        }
                      >
                        {answerAwaitSaving === questionId ? (
                          <div style={{ fontSize: "6px", padding: "4px 1.2px 0px 1.2px" }}>
                            <Spinner
                              style={{ color: "#50a5f1", height: "16px", width: "16px", margin: "0" }}
                            />
                          </div>
                        ) : (
                          <CheckCheck size={18} />
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>

                {/* Question Stats */}
                {confirmedAnswers[questionId] && 
                  <>
                    <div style={{ width: "100%", height: "10px" }}></div>
                    <StatsPane
                      infoQuestion={infoQuestion}

                      visibleStats={visibleStats}
                      toggleStatsOpen={toggleStatsOpen}
                      animatingStats={animatingStats}

                      questionStats={questionStats}
                      setQuestionStats={setQuestionStats}
                      loadStats={loadStats}
                      answerAwaitSaving={answerAwaitSaving}
                      resolvedAnswerBuckets={resolvedAnswerBuckets}
                    />
                  </>
                }

                {/*
                {confirmedAnswers[questionId] && (() => {
                  const isInputtingComment = false;
                  return (
                    <Row>
                      <Col xs={12}>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            transition: "transform 0.3s",
                          }}
                          onClick={() => toggleStatsOpen(questionId)}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              transition: "transform 0.3s",
                              transform: isStatsDisplayed ? "rotate(90deg)" : "rotate(0deg)",
                              marginRight: "4px",
                              fontSize: "8px",
                              color: "#2778b9"
                            }}
                          >▶</span>
                          <p className="mb-0"
                            style={{ fontSize: "12px", color: "#2778b9" }}
                          >{isStatsDisplayed ? "隱藏結果" : "檢視結果"}</p>
                        </div>

                        {visibleStats[questionId] && questionStats[questionId] && (
                          <div 
                            className={animatingStats[questionId] ? "div-reveal" : "div-hide"}
                            style={{
                              marginTop: "10px",
                              padding: "15px 30px 10px 30px",
                              border: "1.4px solid #76aad8",
                              marginBottom: "1rem",
                              borderBottomLeftRadius: "10px",
                              borderBottomRightRadius: "10px",
                              background: "linear-gradient(100deg, #f2f9ff 0%, white 35%, white 75%, #ffeedd 100%)",
                            }}
                          >
                            <Row>
                              <Col xs={12} md={12} className="mb-3">
                                <Row className="d-flex">
                                  <Col xs={6} className="d-flex align-items-center">
                                    <Button 
                                      color="outline-info" 
                                      className="hover-info-button me-2"
                                      onClick={()=>{
                                        reloadStats(questionId);
                                      }}
                                      style={{
                                        display: "flex",
                                        padding: "0.3rem 0.3rem",
                                        height: "25px",
                                        width: "25px",
                                        fontSize: "15px",
                                        background: "white",
                                        color: "#57a0e9"
                                      }}
                                    >
                                      {justRefreshed[questionId] ? <CheckCheck size={14.5}/> : <LuRefreshCw />}
                                    </Button>
                                    <p className="mb-0">總回答數：{questionStats[questionId]?.totalResponses}</p>
                                  </Col>
                                  <Col xs={6}>
                                    <div 
                                      className="forum-link d-flex justify-content-end align-items-center" 
                                      style={{ cursor: "pointer" }}
                                      onClick={()=>{ navigate(`../myInfo/questions/${questionId}/discussions`); }}
                                    >
                                      <p className="mb-0">
                                        <ArrowRight size={18} style={{ marginRight: "4px", marginTop: "-2px" }} />
                                        前往討論
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>

                              <Col xs={12} md={8} style={{ marginBottom: "30px" }}>
                                {(() => {
                                  const stat = questionStats[questionId];
                                  const total = stat.totalResponses || 1;

                                  let totalCounted = 0;

                                  const entries = Object.entries(stat.counts).map(([label, count]) => {
                                    totalCounted += count;
                                    const percentage = ((count / total) * 100).toFixed(1);

                                    return (
                                      <div key={label} style={{ marginBottom: "6px" }}>
                                        <span style={{ display: "inline-block", width: "80px" }}>{label}</span>
                                        <div
                                          style={{
                                            display: "inline-block",
                                            backgroundColor: label===resolvedAnswerBuckets[questionId] ? "#3399ff" : "#ddd",
                                            height: "10px",
                                            width: `${(90 * percentage) / 100}%`,
                                            verticalAlign: "middle",
                                            marginRight: "10px",
                                            borderRadius: "4px",
                                          }}
                                        />
                                        <span>{count} ({percentage}%)</span>
                                      </div>
                                    );
                                  });

                                  const othersCount = Math.max(0, total - totalCounted); // prevent negative if miscounted
                                  const othersPercentage = ((othersCount / total) * 100).toFixed(1);

                                  return (
                                    <>
                                      {entries}
                                      <div>
                                        <span style={{ display: "inline-block", width: "80px" }}>其他</span>
                                        <div
                                          style={{
                                            display: "inline-block",
                                            backgroundColor: !resolvedAnswerBuckets[questionId] ? "#3399ff" : "#ddd",
                                            height: "10px",
                                            width: `${(90 * othersPercentage) / 100}%`,
                                            verticalAlign: "middle",
                                            marginRight: "10px",
                                            borderRadius: "4px",
                                          }}
                                        />
                                        <span>{othersCount} ({othersPercentage}%)</span>
                                      </div>
                                    </>
                                  );
                                })()}
                              </Col>

                              <Col xs={12} md={4} style={{ textAlign: "center" }}>

                                <div className="d-flex justify-content-center" style={{ margin: "0 auto" }}>

                                  {(() => {

                                    const isThumbsUp = questionStats[questionId]?.value==="up";
                                    const isThumbsDown = questionStats[questionId]?.value==="down";

                                    return (
                                      <>
                                        <div 
                                          style={{ 
                                            marginRight: (isThumbsUp || isThumbsDown) ? "12px" : "9px",
                                            transition: "margin 0.2s ease"
                                          }}
                                        >
                                          <div 
                                            style={{
                                              width: "50px", height: "50px",
                                              border: "1.5px solid #cdeccd",
                                              background: isThumbsUp ? "#e9fbe9" : "white",
                                              boxShadow: isThumbsUp ? "0px 0px 4px rgba(0,0,0,0.2)" : undefined,
                                              transform: isThumbsUp ? "scale(1.1)" : undefined,
                                              borderRadius: "6px",
                                              display: "flex", alignItems: "center", justifyContent: "center",
                                              margin: "0 auto",
                                              fontSize: "25px",
                                              transition: "transform 0.2s ease",
                                              cursor: "pointer"
                                            }}
                                            onMouseEnter={(e) => {
                                              if(!isThumbsUp){
                                                e.currentTarget.style.transform = "scale(1.1)";
                                                e.currentTarget.style.boxShadow = "0px 0px 4px rgba(0,0,0,0.2)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if(!isThumbsUp){
                                                e.currentTarget.style.transform = "scale(1)";
                                                e.currentTarget.style.boxShadow = "none";
                                              }
                                            }}
                                            onClick={()=>{ handleThumbsUp(questionId) }}
                                          >
                                            👍
                                          </div>
                                          <div style={{ margin:"5px 0px 10px 0px"}}>{questionStats[questionId].thumbsUp}</div>
                                        </div>

                                        <div>
                                          <div 
                                            style={{
                                              width: "50px", height: "50px",
                                              border: "1.5px solid #f9cccc",
                                              background: isThumbsDown ? "#fff1f1" : "white",
                                              boxShadow: isThumbsDown ? "0px 0px 4px rgba(0,0,0,0.2)" : undefined,
                                              transform: isThumbsDown ? "scale(1.1)" : undefined,
                                              borderRadius: "6px",
                                              display: "flex", alignItems: "center", justifyContent: "center",
                                              margin: "0 auto",
                                              fontSize: "22px",
                                              transition: "transform 0.1s ease",
                                              cursor: "pointer"
                                            }}
                                            onMouseEnter={(e) => {
                                              if(!isThumbsDown){
                                                e.currentTarget.style.transform = "scale(1.1)";
                                                e.currentTarget.style.boxShadow = "0px 0px 4px rgba(0,0,0,0.2)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if(!isThumbsDown){
                                                e.currentTarget.style.transform = "scale(1)";
                                                e.currentTarget.style.boxShadow = "none";
                                              }
                                            }}
                                            onClick={()=>{ handleThumbsDown(questionId) }}
                                          >
                                            👎
                                          </div>
                                          <div style={{ margin:"5px 0px 10px 0px"}}>{questionStats[questionId].thumbsDown}</div>
                                        </div>
                                      </>
                                    );
                                  })()}
                                </div>
                              </Col>

                              {/* Thumbs horizontal bar */}
                              {/*
                              {(() => {
                                const thumbsUp = questionStats[questionId].thumbsUp || 0;
                                const thumbsDown = questionStats[questionId].thumbsDown || 0;
                                const total = thumbsUp + thumbsDown || 1;
                                const thumbsUpPercent = (thumbsUp / total) * 100;
                                const thumbsDownPercent = 100 - thumbsUpPercent;
                                return (
                                  <Col xs={12} md={12} className="d-flex justify-content-center"
                                    style={{ flexDirection: "column" }}
                                  >
                                    <div 
                                      style={{ 
                                        display: "flex", 
                                        alignItems: "center",
                                        flexDirection: "column",
                                        margin: '10px 20px 20px 20px',
                                      }}
                                    >
                                      <div style={{
                                        height: "10px",
                                        width: "80%",
                                        borderRadius: "6px",
                                        overflow: "hidden",
                                        display: "flex"
                                      }}>
                                        <div style={{
                                          width: `${thumbsUpPercent}%`,
                                          backgroundColor: "#7ee5c0",
                                          height: "100%"
                                        }} />
                                        <div style={{
                                          width: `${thumbsDownPercent}%`,
                                          backgroundColor: "#ff8787",
                                          height: "100%"
                                        }} />
                                      </div>
                                      <div style={{
                                        height: "10px",
                                        width: "80%",
                                        display: "flex",
                                        justifyContent: "space-between"
                                      }}>
                                        <p className="mb-0">{thumbsUpPercent.toFixed(1)}%</p>
                                        <p className="mb-0">{thumbsDownPercent.toFixed(1)}%</p>
                                      </div>
                                    </div>

                                  </Col>
                                );
                              })()}
                              */}

                              {/* Thumbs horizontal bar */}
                              {/*
                              <Col xs={12} md={12} style={{ textAlign: "center" }}>
                                {!commentInputOpen[questionId] && (
                                  <Button className="mb-1" color="info" style={{ padding: '5px 15px' }}
                                    onClick={() => toggleCommentInput(questionId)}
                                  >吐槽一下</Button>
                                )}
                                {commentInputOpen[questionId] && (
                                  <Row className="d-flex justify-content-center">
                                    <Col xs={6} md={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                      <Row className="d-flex">
                                        <Col xs={8} md={8}>
                                           <StatsCommentTextArea
                                            questionId={questionId}
                                            value={statsComments[questionId] || ""}
                                            onChange={handleStatsCommentChange}
                                            disabled={answerAwaitSaving}
                                            registerRef={registerRef}
                                          />
                                        </Col>
                                        <Col xs={4} md={4}
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center"
                                          }}
                                        >
                                          <Button 
                                            className="hover-info-button"
                                            color={commentInputSent[questionId] ? "success" : "info"}
                                            style={{
                                              backgroundColor: commentInputSent[questionId] ? "#34c38f" : "#50a5f1",
                                              border: "none",
                                              height: "30px",
                                              width: "30px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              padding: "0px",
                                              transition: "background-color 0s ease-in-out"
                                            }}
                                            onClick={()=>{
                                              sendCommentInput(questionId);
                                            }}
                                          >
                                            {commentInputSent[questionId] === true ? (
                                              <>
                                                <CheckCheck size={16} />
                                                <HoverInfo
                                                  label="吐槽成功"
                                                  styles={{ backgroundColor: "grey" }}
                                                  activeStyles={{ backgroundColor: "grey" }}
                                                />
                                              </>
                                            ) : commentInputSent[questionId] === "loading" ? (
                                              <>
                                                <Spinner
                                                  style={{
                                                    color: "white",
                                                    height: "16px",
                                                    width: "16px",
                                                    margin: "0",
                                                  }}
                                                />
                                                <HoverInfo
                                                  label="吐槽中"
                                                  styles={{ backgroundColor: "grey" }}
                                                  activeStyles={{ backgroundColor: "grey" }}
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <ArrowRight size={16} />
                                                <HoverInfo
                                                  label="吐槽一下嘛"
                                                  styles={{ backgroundColor: "grey" }}
                                                  activeStyles={{ backgroundColor: "grey" }}
                                                />
                                              </>
                                            )}
                                            
                                          </Button>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}
                                
                              </Col>

                            </Row>
                          </div>
                        )}

                      </Col>
                    </Row>
                  )
                })()}
                */}

              </Col>
            </div>
          </CSSTransition>
        </TransitionGroup>

      </Row>
    </TabPane>
  );
};

export default withTranslation()(QuestionPane);


